import Axios from 'axios'
import React, { Component } from 'react'
import Button from '../../Components/Button'
import config from '../../Shared/config'
import { setDevToken, getDevToken } from '../../Utils/Token'
import './DevLogin.scss'

export default class DevLogin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loginForm: {
                userID: '',
                password: '',
            }
        }
    }

    componentDidMount() {
        const token = getDevToken()
        if (token) {
            this.props.history.push('/backdoor/')
        }
    }

    createDev = () => {
        const url = `${config.apiUrl}/Authentication/devregister`
        const obj = {
            firstName: 'Vipin',
            lastName: 'Sharma',
            email: 'vipin.sharma3039@gmail.com',
            contactNumber: '9716753039',
            userID: 'vipin',
            password: '0000',
        }

        Axios.post(url, obj).then(res => {

        }).catch(err => {

        })
    }

    verifyDev = () => {
        const { loginForm } = this.state

        if (loginForm.userID && loginForm.password) {
            const url = `${config.apiUrl}/Authentication/devlogin`
            Axios.post(url, loginForm).then(res => {
                if (!res.data.error) {
                    setDevToken(res.data.data)
                    this.props.history.push('/backdoor/')
                } else {
                    alert(res.data.message)
                }

            }).catch(err => {

            })

        } else {
            alert('Please fill User ID and Password.')
        }
    }

    onChange = (e) => {
        let { loginForm } = this.state
        loginForm[e.target.id] = e.target.value
        this.setState({ loginForm })
    }

    render() {
        const { loginForm } = this.state

        return (
            <div className='dev-login-container'>
                <div className="logocontainer">
                    <img src={`${process.env.PUBLIC_URL}/512x512.png`} alt='logo' /> iCurious
                </div>

                <main>
                    <div className="field">
                        <div className="key">User ID</div>
                        <input id={'userID'} className='value' value={loginForm.userID} onChange={this.onChange} type="text" />
                    </div>
                    <div className="field">
                        <div className="key">Password</div>
                        <input id={'password'} className='value' value={loginForm.password} onChange={this.onChange} type="password" />
                    </div>
                    <Button onClick={this.verifyDev}>Enter</Button>
                </main>

                <footer>
                    This is a dev backdoor. If you are not a developer of iCurious Team please close this website or visit www.iCurious.com
                </footer>
            </div>
        )
    }
}
